import { LitElement as v, unsafeCSS as _ } from "lit";
import { property as r, state as m } from "lit/decorators.js";
import f from "../../shared/reset.style.css.js";
import { deleteSeparatorMask as b, applyMask as g } from "../../utils/mask.js";
import { booleanType as c } from "../../utils/property-types.js";
import y from "./input.style.css.js";
import { template as x } from "./input.template.js";
var S = Object.defineProperty, C = Object.getOwnPropertyDescriptor, s = (o, t, e, a) => {
  for (var i = a > 1 ? void 0 : a ? C(t, e) : t, h = o.length - 1, l; h >= 0; h--)
    (l = o[h]) && (i = (a ? l(t, e, i) : l(i)) || i);
  return a && i && S(t, e, i), i;
};
class n extends v {
  constructor() {
    super(...arguments), this.maskRegex = void 0, this.maskReplace = void 0, this.allowedChars = void 0, this.icon = "add_box", this.inputSize = "lg", this.unit = void 0, this.inputPrefix = void 0, this._label = "Label", this._placeholder = "", this._maxLength = void 0, this._invalid = !1, this._helpText = "", this._isFocused = !1, this._isTypeNumeric = !1, this._inputValidity = !0, this._removeMinWidth = !1, this.observerConfig = { attributes: !0, childList: !0, subtree: !0 }, this.callback = (t) => {
      for (const e of t)
        e.type === "attributes" && (this._checkInputAttributes(), this.requestUpdate());
    }, this.observer = new MutationObserver(this.callback), this._previousValue = void 0, this._isTruncated = !1, this.intervalId = null;
  }
  static get styles() {
    return [_(f), _(y)];
  }
  // Properties
  get _input() {
    var e;
    const t = ((e = this.shadowRoot) == null ? void 0 : e.querySelector('slot[name="input"]')) || void 0;
    return this.requestUpdate(), t == null ? void 0 : t.assignedElements()[0];
  }
  get _labelSlot() {
    var e;
    const t = ((e = this.shadowRoot) == null ? void 0 : e.querySelector('slot[name="label"]')) || void 0;
    return t == null ? void 0 : t.assignedElements()[0];
  }
  set label(t) {
    const e = this._label;
    this._label = t, this.requestUpdate("label", e);
  }
  get label() {
    return this._label;
  }
  set helpText(t) {
    const e = this._helpText;
    this._helpText = t, this.requestUpdate("helpText", e);
  }
  get helpText() {
    return this._helpText;
  }
  set invalid(t) {
    const e = this._invalid;
    this._invalid = t, this.requestUpdate("invalid", e);
  }
  get invalid() {
    return this._invalid;
  }
  set removeMinWidth(t) {
    const e = this._removeMinWidth;
    this._removeMinWidth = t, this.requestUpdate("removeMinWidth", e);
  }
  get removeMinWidth() {
    return this._removeMinWidth;
  }
  set value(t) {
    t !== void 0 && this.requestUpdate();
  }
  get value() {
    var t;
    return ((t = this._input) == null ? void 0 : t.value) || "";
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  _handleClick() {
    this.requestUpdate();
  }
  _handleInput() {
    var t, e;
    if (this._isTypeNumeric && this._maxLength && this._input && (this._input.value = this._input.value.slice(0, this._maxLength)), this.maskRegex && this.maskReplace && this._input) {
      this._previousValue && this._previousValue.length > ((t = this._input) == null ? void 0 : t.value.length) && (this._input.value = b(this._previousValue, this._input.value, this.maskReplace));
      const a = g(this._input.value, this.maskRegex, this.maskReplace, this.allowedChars);
      a !== this._input.value && (this._input.value = a);
    }
    this._previousValue = (e = this._input) == null ? void 0 : e.value, this._handleValidity(), this._dispatchOnChange(), this.requestUpdate();
  }
  _handleFocusIn() {
    this._isFocused = !0, this.requestUpdate();
  }
  _handleFocusOut() {
    this._isFocused = !1, this._checkInputOverflow(), this.requestUpdate();
  }
  _focusInput() {
    var t;
    (t = this._input) == null || t.focus();
  }
  _handleValidity() {
    var e;
    const t = (e = this._input) == null ? void 0 : e.checkValidity();
    t !== void 0 && (this._inputValidity = t);
  }
  _roundFloat(t) {
    return Number.parseFloat(t.toPrecision(12));
  }
  _stepWithFallback(t) {
    var h;
    const e = this._input;
    if (!e) return;
    if (((h = e.getAttribute("step")) == null ? void 0 : h.toLowerCase()) === "any") {
      const l = Number.isFinite(e.valueAsNumber) ? e.valueAsNumber : 0, u = e.hasAttribute("min") ? Number(e.getAttribute("min")) : null, d = e.hasAttribute("max") ? Number(e.getAttribute("max")) : null, p = this._roundFloat(l + t);
      if (u !== null && p < u || d !== null && p > d) return;
      e.value = String(p);
      return;
    }
    try {
      t === 1 ? e.stepUp() : e.stepDown();
    } catch (l) {
      console.error(l);
    }
  }
  _stepUp() {
    this._stepWithFallback(1), this._handleValidity(), this._dispatchValueChange(), this._dispatchOnChange(), this.requestUpdate();
  }
  _stepDown() {
    this._stepWithFallback(-1), this._handleValidity(), this._dispatchValueChange(), this._dispatchOnChange(), this.requestUpdate();
  }
  _dispatchValueChange() {
    if (this._input) {
      const t = {
        detail: this._input.value,
        bubbles: !0,
        composed: !0
      };
      this.dispatchEvent(new CustomEvent("onInputChange", t));
    }
  }
  _dispatchOnChange() {
    if (!this._input) return;
    const t = {
      detail: this._input.value,
      bubbles: !1,
      composed: !1
    };
    this.dispatchEvent(new CustomEvent("onChange", t));
  }
  _checkInputAttributes() {
    var a, i, h, l, u;
    const t = (a = this._input) == null ? void 0 : a.getAttribute("placeholder");
    t && (this._placeholder = t), ((i = this._input) == null ? void 0 : i.getAttribute("type")) === "number" && (this._isTypeNumeric = !0);
    const e = (h = this._input) == null ? void 0 : h.getAttribute("maxlength");
    this._maxLength = e ? +e : void 0, (l = this._input) != null && l.value && ((u = this._input) == null ? void 0 : u.value) !== "" && this._handleValidity();
  }
  _checkInputOverflow() {
    if (!this._input || !this._input.value) return;
    const t = window.getComputedStyle(this._input), e = `${t.fontWeight} ${t.fontSize} ${t.fontFamily}`, i = document.createElement("canvas").getContext("2d");
    if (!i) return;
    i.font = e;
    const h = i.measureText(this._input.value).width;
    this._isTruncated = h > this._input.offsetWidth;
  }
  _onHold(t) {
    this.intervalId = window.setInterval(() => {
      t === "up" ? this._stepUp() : this._stepDown();
    }, 150);
  }
  _stopHold() {
    this.intervalId !== null && (clearInterval(this.intervalId), this.intervalId = null);
  }
  async firstUpdated() {
    try {
      await this.updateComplete, this._input && (this._input.classList.add("dss-input-skip-native"), this._checkInputAttributes(), this.observer.observe(this._input, this.observerConfig)), this.requestUpdate();
    } catch {
      console.error("ERROR OCURRED");
    }
  }
  render() {
    return x(this);
  }
}
s([
  r({ type: String })
], n.prototype, "label", 1);
s([
  r({ type: String })
], n.prototype, "maskRegex", 2);
s([
  r({ type: String })
], n.prototype, "maskReplace", 2);
s([
  r({ type: String })
], n.prototype, "allowedChars", 2);
s([
  r({ type: String })
], n.prototype, "icon", 2);
s([
  r({ type: String })
], n.prototype, "inputSize", 2);
s([
  r({ type: String })
], n.prototype, "unit", 2);
s([
  r({ type: String })
], n.prototype, "inputPrefix", 2);
s([
  r({ type: String })
], n.prototype, "helpText", 1);
s([
  r(c)
], n.prototype, "invalid", 1);
s([
  r(c)
], n.prototype, "removeMinWidth", 1);
s([
  r({ type: String })
], n.prototype, "value", 1);
s([
  m()
], n.prototype, "intervalId", 2);
export {
  n as Input
};
//# sourceMappingURL=input.js.map
